import { lazy } from 'react';

import { UserRoleDto } from '@/api/generated';
import { RouteEnum, RouteModel } from '@/layouts/routes/model/Route.model.ts';
import { Forbidden } from '@/views/generalError/forbidden/Forbidden.comp.tsx';
import NotAuthorized from '@/views/generalError/notAuthorized/NotAuthorized.view.tsx';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

const HomeView = lazy(() => import('@/views/home/Home'));
const ProcessesView = lazy(() => import('@/views/processes/list/Processes.view.tsx'));
const CvSearchListView = lazy(() => import('@/views/cvSearch/list/CvSearchList.view.tsx'));
const CvSearchCreateView = lazy(() => import('@/views/cvSearch/create/CvSearchCreate.view.tsx'));
const ElivionView = lazy(() => import('@/views/auth/elivion/ElivionLogin.view'));
const ProcessesAddons = lazy(
  () => import('@/views/processes/list/addons/ProcessesQuickView.comp.tsx'),
);
const ProcessDetailsView = lazy(() => import('@/views/processes/details/ProcessDetails.view.tsx'));
const CvSearchDetailsView = lazy(
  () => import('@/views/processes/details/cvSearch/CvSearchDetails.view.tsx'),
);
const ProcessDetailsAddons = lazy(
  () => import('@/views/processes/details/addons/ProcessDetailsQuickView.comp.tsx'),
);
const CandidateDetailsView = lazy(
  () => import('@/views/candidates/details/CandidateDetails.view.tsx'),
);
const CandidateDetailsAddons = lazy(
  () => import('@/views/candidates/details/addons/CandidateDetailsQuickView.comp.tsx'),
);
const InterviewSimulationDetailsView = lazy(
  () => import('@/views/interviewSimulations/details/InterviewSimulationDetails.view.tsx'),
);
const InterviewSimulationDetailAddons = lazy(
  () =>
    import('@/views/interviewSimulations/details/addons/InterviewSimulationDetailsQuickView.comp'),
);
const AnalysisRemarksView = lazy(() => import('@/views/analysisRemarks/AnalysisRemarks.view.tsx'));
const MeetingsView = lazy(() => import('@/views/meetings/Meetings.view.tsx'));
const IntakeCallTemplatesView = lazy(
  () => import('@/views/intakeCallTemplates/IntakeCallTemplates.view.tsx'),
);
const MeetingDetailsView = lazy(() => import('@/views/meetings/details/MeetingDetails.view.tsx'));
const StatisticsView = lazy(() => import('@/views/statistics/Statistics.view.tsx'));
const ExperienceCompaniesView = lazy(
  () => import('@/views/experienceCompanies/ExperienceCompanies.view.tsx'),
);
const ProcessTemplatesView = lazy(
  () => import('@/views/admin/processTemplates/ProcessTemplates.view.tsx'),
);
const TagsView = lazy(() => import('@/views/tags/Tags.view.tsx'));
export const ROUTES: RouteModel[] = [
  {
    component: HomeView,
    path: RouteEnum.ROOT,
  },
  {
    addons: ProcessesAddons,
    component: ProcessesView,
    path: RouteEnum.PROCESSES,
  },
  {
    component: CvSearchListView,
    path: RouteEnum.CV_SEARCH,
  },
  {
    component: CvSearchCreateView,
    path: RouteEnum.CV_SEARCH_CREATE,
  },
  {
    component: CvSearchCreateView,
    path: RouteEnum.CV_SEARCH_CREATE_ALIAS,
  },
  {
    addons: ProcessDetailsAddons,
    component: ProcessDetailsView,
    path: RouteEnum.PROCESS_DETAILS,
  },
  {
    component: CvSearchDetailsView,
    path: RouteEnum.PROCESS_CV_SEARCH_DETAILS,
  },
  {
    addons: CandidateDetailsAddons,
    component: CandidateDetailsView,
    path: RouteEnum.CANDIDATE_DETAILS,
  },
  {
    addons: InterviewSimulationDetailAddons,
    component: InterviewSimulationDetailsView,
    path: RouteEnum.INTERVIEW_SIMULATION,
  },
  {
    component: AnalysisRemarksView,
    path: RouteEnum.ANALYSIS_REMARKS,
  },
  {
    component: MeetingsView,
    path: RouteEnum.MEETINGS,
  },
  {
    component: MeetingDetailsView,
    path: RouteEnum.MEETING_DETAILS,
  },
  {
    component: IntakeCallTemplatesView,
    path: RouteEnum.INTAKE_CALL_TEMPLATES,
  },
  {
    component: StatisticsView,
    path: RouteEnum.STATISTICS,
    roles: [UserRoleDto.Admin],
  },
  {
    component: ExperienceCompaniesView,
    path: RouteEnum.EXPERIENCE_COMPANIES,
    roles: [UserRoleDto.Admin],
  },
  {
    component: ProcessTemplatesView,
    path: RouteEnum.PROCESS_TEMPLATES,
    roles: [UserRoleDto.Admin],
  },
  {
    component: TagsView,
    path: RouteEnum.TAGS,
    roles: [UserRoleDto.Admin],
  },
  {
    component: Forbidden,
    path: RouteEnum.FORBIDDEN,
  },
  {
    component: NotFound,
    path: RouteEnum.NOT_FOUND,
  },
  {
    component: NotAuthorized,
    path: RouteEnum.NOT_AUTHORIZED,
  },
  {
    component: ElivionView,
    path: RouteEnum.LOGIN_ELIVION,
  },
];
